<template>
  <PartnerListWidget :href="ctaLink" @click="onLinkClick">
    <template #icon>
      <HgIcon icon="DebtCertificate" size="large" theme="secondary" />
    </template>
    <template #content>
      <span>
        {{ t('integrations.crif.message') }}
        <span :class="$style.cta">{{ ctaAction }}</span>
      </span>
    </template>
  </PartnerListWidget>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { computed } from 'vue';

import PartnerListWidget from '@/components/PartnerIntegrations/PartnerListWidget/PartnerListWidget.vue';
import { InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { resolveUrl } from '@/helpers/HgLink/HgLinkHelper';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'Crif',
});

const { t } = useI18n();
const emit = defineEmits<{
  trackPartnerLink: [ctaLink: string, goal: InteractionGoal];
}>();

const ctaLink = computed((): string => {
  return resolveUrl(t('integrations.crif.link.url'));
});

const ctaAction = computed((): string => {
  return t('integrations.crif.link.text');
});

const onLinkClick = (): void => {
  emit('trackPartnerLink', ctaLink.value, InteractionGoal.ORDER_DEBT_COLLECTION_REGISTER);
};
</script>
<style lang="scss" module>
@import '@/assets/variables';

.cta {
  color: var(--base-color-link);

  @include font-bold;
}
</style>
